import { render, staticRenderFns } from "./MainLedgerPayList.vue?vue&type=template&id=455d1704&scoped=true"
import script from "./MainLedgerPayList.vue?vue&type=script&lang=js"
export * from "./MainLedgerPayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d1704",
  null
  
)

export default component.exports